import { Link, useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { LogOut, User as UserIcon } from "lucide-react";

export default function TopBar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-[#132741]/95 backdrop-blur border-b border-[#556B2F]/10">
      <div className="mx-auto max-w-7xl px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="top-home-link"><Logo /></Link>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-200">
          <Link to="/#coupon" className="hover:text-[#556B2F]" data-testid="nav-coupon">Coupon</Link>
          <Link to="/#how" className="hover:text-[#556B2F]" data-testid="nav-how">How it works</Link>
          <Link to="/#faq" className="hover:text-[#556B2F]" data-testid="nav-faq">FAQ</Link>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Button variant="outline" onClick={() => nav(user.role === "admin" ? "/admin" : "/app")} data-testid="btn-open-dashboard">
                <UserIcon className="h-4 w-4 mr-1" /> Dashboard
              </Button>
              <Button variant="ghost" onClick={() => { logout(); nav("/"); }} data-testid="btn-logout-top">
                <LogOut className="h-4 w-4 mr-1" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" onClick={() => nav("/login")} data-testid="btn-login-top">Login</Button>
              <Button className="bg-[#556B2F] hover:bg-[#2A331A] text-white" onClick={() => nav("/register")} data-testid="btn-register-top">
                Get Started
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
